export default __webpack_public_path__ + "static/media/opera_icon.ce38a92d.png";